'use client'

import {
  createContext,
  useContext,
  type ReactNode,
} from 'react'

type PromanityShellContextValue = {
  sellerId: number
  loggedIn: boolean
  userId: number | string | null
  features: Record<string, any> | null
  isAffiliateActive: boolean
  inviteUrl: string | null
}

const PromanityShellContext =
  createContext<PromanityShellContextValue | null>(null)

type PromanityShellProviderProps =
  PromanityShellContextValue & {
    children: ReactNode
  }

export function PromanityShellProvider({
  children,
  sellerId,
  loggedIn,
  userId,
  features,
  isAffiliateActive,
  inviteUrl,
}: PromanityShellProviderProps) {
  return (
    <PromanityShellContext.Provider
      value={{
        sellerId,
        loggedIn,
        userId,
        features,
        isAffiliateActive,
        inviteUrl,
      }}
    >
      {children}
    </PromanityShellContext.Provider>
  )
}

export function usePromanityShellContext() {
  const context = useContext(PromanityShellContext)

  if (!context) {
    throw new Error(
      'usePromanityShellContext debe usarse dentro de PromanityShellProvider'
    )
  }

  return context
}